// dependencies imports ⇒
import React from "react";
// assets and scss imports ⇒
import InfoIcon from "../../../assets/info.png";
import "./raiseInvoiceHeader.scss";
import BackIcon from "../../../assets/buttonArrow.svg";

const RaiseInvoiceHeader = (props) => {
  const { onRaiseInvoiceClose } = props;

  // create UI ⇒
  const raiseInvoiceHeaderUI = () => {
    return (
      <div className="raise-invoice-header-container">
        <div className="raise-invoice-close-icon-container">
          <img
            src={BackIcon}
            alt=""
            className="raise-invoice-close-icon"
            onClick={onRaiseInvoiceClose}
          />
        </div>
        <div>
          <div className="raise-invoice-header-content">
            <div className="raise-invoice-header">
              <div className="raise-invoice-header-title">Raise Invoice</div>
              <small
                data-tooltip="Confirm the details and click the submit option to raise an invoice.This will appear on my appointments and transactions."
                data-tooltip-conf="multiline bottom"
              >
                <img
                  src={InfoIcon}
                  className="raise-invoice-info-icon"
                  alt="info"
                />
              </small>
            </div>
          </div>
          <div>
            <p className="raise-invoice-sub-title">
              Review and confirm billing information for your patient.
            </p>
          </div>
        </div>
      </div>
    );
  };

  return <>{raiseInvoiceHeaderUI()}</>;
};

//export
export default RaiseInvoiceHeader;
